import { render, staticRenderFns } from "./componentSelector.vue?vue&type=template&id=036402b6"
import script from "./componentSelector.vue?vue&type=script&lang=js"
export * from "./componentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports